// extracted by mini-css-extract-plugin
export var emptyState = "_6w-d";
export var statCard = "_6w-c";
export var table = "_6w-0";
export var tableCell = "_6w-4";
export var tableCellClickable = "_6w-5 _6w-4";
export var tableCellDefault = "_6w-6 _6w-4";
export var tableCellEmpty = "_6w-8";
export var tableCellWithValue = "_6w-7";
export var tableContainer = "_6w-e";
export var tableHeaderWeight = "_6w-1";
export var tableHeaderZone = "_6w-2";
export var tableRowHeader = "_6w-3";
export var viewModeButton = "_6w-9";
export var viewModeButtonActive = "_6w-a _6w-9";
export var viewModeButtonInactive = "_6w-b _6w-9";